export const SUNDAY = 1;
export const MONDAY = 2;
export const TUESDAY = 3;
export const WEDNESDAY = 4;
export const THURSDAY = 5;
export const FRIDAY = 6;
export const SATURDAY = 7;
export const DayOfWeekValues = {
  SUNDAY,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY
};
export const DayOfWeekTranslationKeys = {
  [SUNDAY]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.days.sunday',
  [MONDAY]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.days.monday',
  [TUESDAY]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.days.tuesday',
  [WEDNESDAY]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.days.wednesday',
  [THURSDAY]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.days.thursday',
  [FRIDAY]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.days.friday',
  [SATURDAY]: 'automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.days.saturday'
};